/**
 * AI Scribe V2 — animated "listening" equaliser
 *
 * Three bars that bounce while the scribe is capturing audio and flatten when
 * paused/stopped, mirroring the status colour in the window header.
 *
 * @author [Rajkumar Rathod]
 */

import Flex from "../../../../../../../../../../components/Flex";
import {
  PRIMITIVE,
  px,
} from "../../../../../../../../../../tokens/design-tokens";

const BAR_DELAYS = ["0s", "0.18s", "0.36s"];

interface ListeningWaveIconProps {
  color: string;
  /** Bars only animate while live — a paused session shows a static equaliser */
  animated?: boolean;
  size?: number;
}

const ListeningWaveIcon = ({
  color,
  animated = true,
  size = PRIMITIVE.spacing[16],
}: ListeningWaveIconProps) => (
  <Flex
    alignItems="flex-end"
    justifyContent="center"
    gap={px(PRIMITIVE.spacing[2])}
    height={px(size)}
    sx={{
      "@keyframes scribe-wave": {
        "0%, 100%": { transform: "scaleY(0.35)" },
        "50%": { transform: "scaleY(1)" },
      },
    }}
  >
    {BAR_DELAYS.map((delay) => (
      <Flex
        key={delay}
        sx={{
          width: px(PRIMITIVE.spacing[2]),
          height: px(size),
          borderRadius: px(PRIMITIVE.radius.max),
          backgroundColor: color,
          transformOrigin: "bottom",
          transform: animated ? undefined : "scaleY(0.45)",
          animation: animated
            ? `scribe-wave 1.1s ease-in-out ${delay} infinite`
            : "none",
        }}
      />
    ))}
  </Flex>
);

export default ListeningWaveIcon;
